import { SPLIT_NAMES } from '@/constants';
import notify, { NotificationType } from '@/notify';
import { useUserStore } from '@/piniaStores/user/user.store';
import { SystemNotification } from '@/services/api/models/systemNotifications';
import { getSystemNotifications } from '@/services/api/systemNotifications';

export async function notifyPendingSystemNofications() {
  const userStore = useUserStore();

  if (userStore.user && userStore.getIsSplitEnabled(SPLIT_NAMES.SSR_IFRAME)) {
    const systemNotifications = await getSystemNotifications();

    const notifyTypeMap: { [level in SystemNotification['levelTag']]: NotificationType } = {
      debug: 'info',
      info: 'info',
      success: 'success',
      warning: 'warning',
      error: 'error',
    };

    systemNotifications.forEach((notification) => {
      notify[notifyTypeMap[notification.levelTag]](notification.message);
    });
  }
}
